// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".org {\n  height: 100%;\n}\n.org .el-card__header {\n  padding: 10px;\n}\n.org .el-card__body {\n  padding: 10px;\n  max-height: 520px;\n  overflow: auto;\n}\n.userDialog .el-dialog__body {\n  padding: 10px 0px 0px 10px;\n  color: #606266;\n  font-size: 14px;\n  word-break: break-all;\n}\n.userDialog .el-main {\n  padding: 20px 20px 5px 20px;\n}\n.userDialog .el-main .el-pagination {\n  margin-top: 5px;\n}", ""]);
// Exports
module.exports = exports;
